import { Button, Typography } from '@sky-distribution/react-commons-ui';
import styled from 'styled-components';

export const BannerContainer = styled.section`
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: ${({ theme }) => theme.palette.commons.tonal.base};
  z-index: 1;
`;

export const BannerWrapper = styled.div`
  box-sizing: border-box;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  width: clamp(17.5rem, 100%, 87.5rem);
  margin: 0 auto;

  ${({ theme }) => theme.down(theme.breakpoints.sm)} {
    flex-direction: column;
  }
`;

export const BannerText = styled(Typography)`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.header};
`;

export const BannerLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.text.header};
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

export const BannerButton = styled(Button)`
  ${({ theme }) => theme.down(theme.breakpoints.sm)} {
    width: 100%;
  }
`;
